// extracted by mini-css-extract-plugin
export default {"personalSettingsPage":"styles_personalSettingsPage__vV9yr","title":"styles_title__Fy6os","header":"styles_header__33Hug"};